import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { Observable } from "rxjs";
import { ResponsePropietarioFisica } from "../pojos/responsePropietarioFisica";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class GuardarCambiosEdicionEstatalFisica {
    private endPoint: string = `${environment.HOST_EDICION}/guardar-cambios-edicion-estatales`;

    constructor(private http: HttpClient) {

    }

    guardarEdicionEstatalFisica(data:any): Observable<ResponsePropietarioFisica>{
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post<ResponsePropietarioFisica>(this.endPoint, data, {headers});
    }
}